import { motion } from "framer-motion";
import { SectionLabel, CtaButton, Reveal } from "./shared";

const LINES = [
  { text: "A SIX-FIGURE PURCHASE", cls: "text-white" },
  { text: "SHOULD NOT FEEL", cls: "text-white/[0.28]" },
  { text: "LIKE DECODING", cls: "text-white" },
  { text: "FINE PRINT.", cls: "text-[#0162CA]" },
];

export default function Manifesto() {
  let wordIndex = 0;
  return (
    <section className="relative py-28 lg:py-40 px-6 lg:px-10 overflow-hidden" data-testid="manifesto-section">
      <div className="absolute right-8 top-1/2 -translate-y-1/2 hidden lg:grid grid-cols-8 gap-2 opacity-100 pointer-events-none">
        {Array.from({ length: 64 }).map((_, i) => (
          <div key={i} className="w-3 h-3 bg-[#0162CA]/[0.06]" />
        ))}
      </div>
      <div className="max-w-6xl mx-auto">
        <SectionLabel n="001" text="THE PROBLEM" />
        <h2
          className="font-black uppercase"
          style={{ fontSize: "clamp(36px, 5.5vw, 68px)", lineHeight: 0.97, letterSpacing: "-0.02em" }}
          data-testid="manifesto-statement"
        >
          {LINES.map((line, li) => (
            <span key={li} className={`block ${line.cls}`}>
              {line.text.split(" ").map((w, wi) => {
                const d = wordIndex++ * 0.04;
                return (
                  <motion.span
                    key={wi}
                    className="inline-block mr-[0.28em]"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6, delay: d, ease: [0.22, 1, 0.36, 1] }}
                  >
                    {w}
                  </motion.span>
                );
              })}
            </span>
          ))}
        </h2>
        <Reveal delay={0.3} className="mt-10 max-w-[560px]">
          <p className="text-white/55 text-base leading-[1.75]">
            Most buyers exploring VA-backed financing collect rate quotes built on different assumptions — and nobody
            explains how entitlement, an existing property, current obligations, and cash-to-close actually interact.
            One number gets compared against another number, and the deal underneath stays invisible. This free class
            walks through the whole transaction instead of one line of it, so you can see how the pieces connect
            before you decide anything.
          </p>
          <div className="mt-8">
            <CtaButton outline testId="manifesto-cta">RESERVE MY FREE SEAT →</CtaButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
